import React, { useEffect, useState } from "react";
import { Dropdown } from "colbi_web_ui/lib/components/inputs";
import styles from "./YearSelector.module.sass";
import { parseFilter } from "colbi_web_ui/lib/utils";

export const calendarOptions = [
    { id: 1, name: "Fiscal Year", filterName: "fiscalyear" },
    { id: 2, name: "Calendar Year", filterName: "calendaryear" },
];

const getFilterData = (filterParsed, column) => {
    let itemFound;
    if (filterParsed?.length) {
        itemFound = filterParsed.find((item) => {
            if (item.column === column) {
                return true;
            }
            return false;
        });
    }

    return itemFound;
};

export const getDefaultYearType = (filter) => {
    const parsedFilter = parseFilter(filter);
    const year_type = getFilterData(parsedFilter, "year_type");

    if (year_type) {
        const value = year_type?.filters?.[0]?.value;

        if (value) {
            return calendarOptions.find((item) => {
                return item.filterName === value;
            });
        }
    } else {
        return calendarOptions[0];
    }
};

const YearSelector = ({
    years = [],
    selectedYearType = calendarOptions[0],
    selectedYear,
    setSelectedYearType,
    setSelectedYear,
    filter,
    loadingOverview,
}) => {
    const [yearOptions, setYearOptions] = useState({});
    const [filterParsed, setFilterState] = useState(null);
    const selectedYearOptions = selectedYearType?.filterName
        ? yearOptions[selectedYearType?.filterName]
        : [];

    const buildYearOptions = (years) => {
        const fiscalYears = (years?.fiscalyear || []).map((item, id) => {
            return { id: id + 1, name: item };
        });

        const calendarYears = (years?.calendaryear || []).map((item, id) => {
            return { id: id + 1, name: item };
        });

        const calendarMapObj = {
            fiscalyear: fiscalYears,
            calendaryear: calendarYears,
        };

        return calendarMapObj;
    };

    useEffect(() => {
        if (years && !loadingOverview) {
            const yearOptions = buildYearOptions(years);
            setYearOptions(yearOptions);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(years)]);

    useEffect(() => {
        const parsedFilter = parseFilter(filter);
        const year = getFilterData(parsedFilter, "year");

        if (year && filterParsed !== filter && selectedYearOptions?.length) {
            const value = year?.filters?.[0]?.value;

            if (value) {
                const newOption =
                    (selectedYearOptions || []).find((item) => {
                        return item.name === value;
                    }) || null;

                if (!newOption) {
                    setSelectedYear(selectedYearOptions?.[0]);
                } else if (newOption && selectedYear?.name !== newOption?.name) {
                    setSelectedYear(newOption);
                }

                setFilterState(filter);
            }
        } else if (selectedYearOptions?.[0]) {
            // default item
            setSelectedYear(selectedYearOptions?.[0]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filter, selectedYearOptions]);

    useEffect(() => {
        const parsedFilter = parseFilter(filter);
        const year_type = getFilterData(parsedFilter, "year_type");

        if (year_type) {
            const value = year_type?.filters?.[0]?.value;

            if (value) {
                const newOption = calendarOptions.find((item) => {
                    return item.filterName === value;
                });

                if (selectedYearType?.filterName !== newOption?.filterName) {
                    setSelectedYearType(newOption);
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filter]);

    return (
        <div className={styles["year-selector"]}>
            <>
                <Dropdown
                    style={{ marginRight: "5px" }}
                    placeholder="-- select a year --"
                    value={selectedYear}
                    onChange={({ target }) => {
                        setSelectedYear(target.value);
                    }}
                    options={selectedYearOptions}
                />
                <Dropdown
                    style={{ marginLeft: "5px" }}
                    placeholder="-- select a year type --"
                    value={selectedYearType}
                    onChange={({ target }) => {
                        const yearOptionsParsed = target?.value
                            ? yearOptions[target.value.filterName]
                            : [];
                        setSelectedYear(yearOptionsParsed?.[0]);
                        setSelectedYearType(target.value);
                    }}
                    options={calendarOptions}
                />
            </>
        </div>
    );
};

export default YearSelector;
